var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "一键进仓",
        "destroy-on-close": ""
      },
      on: { close: _vm.onClose }
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "show-message": false } },
        [
          _c(
            "el-form-item",
            {
              attrs: { label: "实际进仓时间", required: "", prop: "incomeDate" }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  clearable: ""
                },
                model: {
                  value: _vm.form.incomeDate,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "incomeDate", $$v)
                  },
                  expression: "form.incomeDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("p", { staticStyle: { color: "red" } }, [
        _vm._v("是否确定所有货物都已进仓，且实际进仓信息与预报一致？")
      ]),
      _c(
        "el-row",
        {
          staticStyle: { "margin-top": "15px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-col",
            { attrs: { span: 18, offset: 6 } },
            [
              _c("el-form", [
                _c(
                  "span",
                  [
                    _c("el-button", { on: { click: _vm.onClose } }, [
                      _vm._v("取 消")
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSubmit }
                      },
                      [_vm._v("确定")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }